import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import ProfilingEazyGender from '@common/influencer/parts/profiling/profiling-eazy-gender';
import ProfilingGeneGender from '@common/influencer/parts/profiling/profiling-gene-gender';
import ProfilingWordcloud  from '@common/influencer/parts/profiling/profiling-wordcloud';
import ProfilingCategory   from '@common/influencer/parts/profiling/profiling-category';
// -------------------------------------------------------

class Profiling extends React.Component {
  /*
   * データ取得
   */
  refreshdProfiling() {
    let chk = confirm('プロファイリングの修正を実施します。よろしいですか？\n※最新のデータに更新するのではなくデータの補填をする作業となります。');
    if( chk == false ) return;
    
    Utils.request.bind(this)('/api/influencer/refresh_profiling', { insta_user_id: this.props.data.insta_user_id },
      function(res){
        alert('プロファイリングを修正します。完了までしばらくお待ち下さい。');
        this.props.refresh_ev.bind(this)();
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    
    if( this.props.ng_html != null ) return this.props.ng_html;
    
    if( Object.keys(data.profiling).length == 0 || data.profiling.finish == 0 ){
      let end_hours = 3;
      if( data.profiling.after_count != undefined ) end_hours += (data.profiling.after_count / 10);
      
      // エラー判定
      if( data.profiling.error == 1 ){
        return (
          <div className="influencer-profiling">
            <div className="none">
              <h2>プロファイリングエラー</h2>
            </div>
          </div>
        );
      }
      
      // 取得中
      return (
        <div className="influencer-profiling">
          { (data.profiling.register_date == undefined)
            ? <div className="none">
                <h2>プロファイリング取得中です (終了時間未定)</h2>
              </div>
            : <div className="none">
                <h2>プロファイリング取得中です ({data.profiling.fix_per}%)</h2>
                <div className="register_date" style={{ marginTop: 20 }}>登録日時：{Utils.setDate(data.profiling.register_date, 'YYYY/M/D HH:mm')}</div>
                <div className="register_date">完了予定：{Moment(data.profiling.register_date).add(end_hours, 'hours').format('YYYY/M/D HH:mm')}</div>
                <h6 style={{ marginTop: 20 }}>※完了予定時間は、他の登録状況によって遅くなる可能性がございます。早めることはできませんのでご了承下さい</h6>
              </div>
          }
          
        </div>
      );
    }
    
    return (
      <div className="influencer-profiling">
        <div className="refresh-button" onClick={this.refreshdProfiling.bind(this)}>プロファイリングを修正する</div>
        <div className="profiling-box">
          <ProfilingEazyGender title="フォロワーの性別比" mode="graph" profiling={data.profiling} />
          <ProfilingWordcloud title="自身のワードクラウド" wordcloud={data.profiling.my_wordcloud} />
          <ProfilingCategory title="自身の投稿頻度の高いコンテンツ" category={data.profiling.my_category} type="my" />
        </div>
        
        <div className="profiling-box">
          <ProfilingGeneGender title="フォロワーの年代/性別比" mode="graph" profiling={data.profiling.followers_profiling} />
          <ProfilingWordcloud title="フォロワーのワードクラウド" wordcloud={data.profiling.followers_wordcloud} />
          <ProfilingCategory title="フォロワーの興味関心" category={data.profiling.followers_category} type="follower" />
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Profiling;